import { matchPath, match } from 'react-router';
import { PARTS_PATH, PARTS_PATH_EDIT } from '@app/react/const/variables';
import { OrderPathParams, EditOrderPathParams } from '@app/react/const/type';

type GetPathParams = () => match<OrderPathParams> | match<EditOrderPathParams> | null;

const isEditCart = (str: string) => /order_made\/edit_cart/.exec(String(str));

export const getPathParams: GetPathParams = () => {
    const { pathname } = window.location;

    // 前提として saga 層で react hook が使えないため、 arrowtype が取得できない
    // matchPath を使って取得するが、 editCart 時だけこの関数をうまく差し替えれないので、
    // 正規表現をつかって切り替えている
    if (isEditCart(pathname) !== null) {
        const path = `/order_made/edit_cart${PARTS_PATH_EDIT}`;
        const params = matchPath<EditOrderPathParams>(pathname, {
            path,
            exact: false,
            strict: false,
        });
        return params;
    }

    const path = `/order_made${PARTS_PATH}`;
    const params = matchPath<OrderPathParams>(pathname, {
        path,
        exact: false,
        strict: false,
    });

    return params;
};
